import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import ExpandableTable, {
  ExpandableTableRow,
} from 'lib/designSystem/ExpandableTable';
import React from 'react';

import MovementsTable from './Table';

const COLUMNS = ['Cuenta', 'Nombre'];

interface MajorBookEntriesTableProps {
  entries: {
    majorBookAccounts: Array<{
      account: string;
      accountName?: string;
      groupedLines: unknown[];
    }>;
    groupedByCategoryAndBusiness?: Record<string, unknown>;
  };
  refreshData?: (showLoading?: boolean) => Promise<void>;
  startDate?: Date;
  endDate?: Date;
  loading?: boolean;
  balanceType?: string;
}

const MajorBookEntriesTable: React.FC<MajorBookEntriesTableProps> = (props) => {
  const { majorBookAccounts, groupedByCategoryAndBusiness } = props.entries;
  const {
    refreshData,
    startDate,
    endDate,
    loading = false,
    balanceType = 'Libro Mayor',
  } = props;

  const rows: ExpandableTableRow[] = majorBookAccounts.map((day, dayIndex) => ({
    id: day.account ?? dayIndex,
    cells: [day.account, day.accountName ?? ''],
    expandedContent: (
      <MovementsTable
        groupedLines={
          day.groupedLines as Parameters<
            typeof MovementsTable
          >[0]['groupedLines']
        }
        groupedByCategoryAndBusiness={
          (groupedByCategoryAndBusiness ?? {}) as Parameters<
            typeof MovementsTable
          >[0]['groupedByCategoryAndBusiness']
        }
        refreshData={refreshData}
        startDate={startDate}
        endDate={endDate}
        balanceType={balanceType}
        detailCode={day.account}
        detailName={day.accountName ?? ''}
      />
    ),
  }));

  return (
    <div style={{ paddingBottom: 100 }}>
      {loading && (
        <Box sx={{ width: '100%' }}>
          <LinearProgress />
        </Box>
      )}
      <ExpandableTable
        columns={COLUMNS}
        rows={rows}
        loading={loading}
        skeletonRowCount={30}
      />
    </div>
  );
};

export default MajorBookEntriesTable;
